import { Component, Input } from '@angular/core';

import { Group }            from './../../../../models/program/group';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.less']
})

export class GroupsComponent {
  @Input() groups: Group;
  @Input() programId: number;

  constructor() { }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/groups.component.ts